import z from 'zod';
import { SanityDocumentSchema, SanityImageObjectSchema } from '../sanity';
import { ComponentType } from '$lib/sanity/types';
import { TextBlockSchema } from './Text';

export const IconStackIconSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.IconStackIcon),
  name: z.string(),
  svg: SanityImageObjectSchema
});

export const IconStackSchema = SanityDocumentSchema.extend({
  _type: z.literal(ComponentType.IconStack),
  orientation: z
    .union([z.literal('horizontal'), z.literal('vertical')])
    .nullish()
    .transform((x) => x ?? 'horizontal'),
  alignment: z
    .union([z.literal('flex-start'), z.literal('center'), z.literal('flex-end')])
    .nullish()
    .transform((x) => x ?? 'flex-start'),
  icon: IconStackIconSchema,
  body: z.array(TextBlockSchema)
});

export type IconStackIcon = z.infer<typeof IconStackIconSchema>;
export type IconStack = z.infer<typeof IconStackSchema>;
